// src/pages/addContractTemplate.jsx
import React, { useState } from 'react';
import { motion } from "framer-motion";
import { ScrollRestoration } from 'react-router-dom';

import axiosInstance from '../utils/axiosInstance';

import PageTitle from '../components/common/pageTitle';
import { slideUp } from '../utils/slideUp';

const AddContractTemplate = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isFree, setIsFree] = useState(true);
  const [price, setPrice] = useState(0);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    try {
      const response = await axiosInstance.post('/api/contract/contract-templates/add-contract-templates', {
        title,
        content,
        isFree,
        price: isFree ? 0 : price,
      });

      setSuccessMessage('Contract template added successfully!');
      setTitle('');
      setContent('');
      setIsFree(true);
      setPrice(0);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Something went wrong. Please try again later.');
    }
  };

  return (
    <>
      <PageTitle link={"Add Contract Template"} pageName={"Add Contract Template"} />

      <div className="add-contract-template-area ptb-100">
        <div className="container">
          <motion.div className="add-contract-template-info"
            initial="offscreen"
            whileInView="onscreen"
            variants={slideUp(1)}
            viewport={{ once: true, amount: 0 }}
          >
            <h1>Add a New Contract Template</h1>
            <form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger">{error}</div>}
              {successMessage && <div className="alert alert-success">{successMessage}</div>}
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control"
                  placeholder="Content"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  required
                  rows="5"
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={isFree}
                    onChange={(e) => setIsFree(e.target.checked)}
                  />
                  Is this template free?
                </label>
              </div>
              {!isFree && (
                <div className="form-group">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Price (points)"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    required={!isFree}
                    min="0"
                  />
                </div>
              )}
              <button className="default-btn border-0" type="submit">
                <i className="ri-arrow-right-line"></i>
                Add Template
              </button>
            </form>
          </motion.div>
        </div>
      </div>
      <ScrollRestoration />
    </>
  );
};

export default AddContractTemplate;

